require('./bootstrap');
require('./animations/fade-in-sections');
require('./animations/lax-animations');
require('./components/slider');
require('./components/mask')
